export default __webpack_public_path__ + "static/media/Akansha.ace5bab8.jpg";